(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('ResourceType', ResourceType);

    ResourceType.$inject = ['$resource', 'DateUtils'];

    function ResourceType ($resource, DateUtils) {
        var resourceUrl =  'api/resource-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ResourceTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getresourcetypebyname = function (data,callback){
		$http.get('api/resource-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('ResourceTypeSearch', ResourceTypeSearch);

    ResourceTypeSearch.$inject = ['$resource'];

    function ResourceTypeSearch ($resource) {
        var service = $resource('/api/resource-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomResourceTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-resource-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();